import React from "react";
import { ArrowUp, ArrowDown, Trash2, Plus } from "lucide-react";

export const StatsEditor = ({ value, onChange }) => {
  const stats = value || [];
  const update = (i, key, v) => onChange(stats.map((s, idx) => (idx === i ? { ...s, [key]: v } : s)));
  const move = (i, dir) => {
    const arr = [...stats];
    const j = i + dir;
    if (j < 0 || j >= arr.length) return;
    [arr[i], arr[j]] = [arr[j], arr[i]];
    onChange(arr);
  };
  const del = (i) => onChange(stats.filter((_, idx) => idx !== i));
  const add = () => onChange([...stats, { icon: "Sparkles", title: "NEW", sub: "Description" }]);
  return (
    <div className="space-y-3">
      {stats.map((s, i) => (
        <div key={i} data-testid={`stat-row-${i}`} className="rounded-2xl border border-[#262626] bg-[#141414] p-4 space-y-2">
          <div className="flex items-center justify-between">
            <div className="text-xs uppercase tracking-widest text-[#FF6600] font-bold">Item #{i + 1}</div>
            <div className="flex items-center gap-1">
              <button onClick={() => move(i, -1)} disabled={i === 0} className="w-8 h-8 rounded-full border border-[#262626] grid place-items-center disabled:opacity-30 hover:border-[#FF6600]"><ArrowUp className="w-3.5 h-3.5" /></button>
              <button onClick={() => move(i, 1)} disabled={i === stats.length - 1} className="w-8 h-8 rounded-full border border-[#262626] grid place-items-center disabled:opacity-30 hover:border-[#FF6600]"><ArrowDown className="w-3.5 h-3.5" /></button>
              <button onClick={() => del(i)} className="w-8 h-8 rounded-full border border-[#262626] grid place-items-center hover:border-red-500 hover:text-red-500"><Trash2 className="w-3.5 h-3.5" /></button>
            </div>
          </div>
          <div className="grid sm:grid-cols-3 gap-2">
            <div>
              <label className="text-[10px] uppercase tracking-widest text-[#A3A3A3]">Icon (lucide name)</label>
              <input value={s.icon || ""} onChange={(e) => update(i, "icon", e.target.value)} placeholder="Target / Zap / Gem …" className="mt-1 w-full bg-[#0F0F0F] border border-[#262626] rounded-lg px-3 py-2 text-sm focus:outline-none focus:border-[#FF6600]" />
            </div>
            <div>
              <label className="text-[10px] uppercase tracking-widest text-[#A3A3A3]">Title</label>
              <input value={s.title || ""} onChange={(e) => update(i, "title", e.target.value)} className="mt-1 w-full bg-[#0F0F0F] border border-[#262626] rounded-lg px-3 py-2 text-sm focus:outline-none focus:border-[#FF6600]" />
            </div>
            <div>
              <label className="text-[10px] uppercase tracking-widest text-[#A3A3A3]">Sub-label</label>
              <input value={s.sub || ""} onChange={(e) => update(i, "sub", e.target.value)} className="mt-1 w-full bg-[#0F0F0F] border border-[#262626] rounded-lg px-3 py-2 text-sm focus:outline-none focus:border-[#FF6600]" />
            </div>
          </div>
        </div>
      ))}
      <button onClick={add} className="ur-btn-secondary text-xs py-2 px-3">
        <Plus className="w-3.5 h-3.5" /> Add Feature Icon
      </button>
      <p className="text-[11px] text-[#A3A3A3] leading-relaxed">
        Icon names come from the <span className="text-white">lucide-react</span> library (e.g. <code className="text-[#FF6600]">Target</code>, <code className="text-[#FF6600]">Zap</code>, <code className="text-[#FF6600]">Gem</code>, <code className="text-[#FF6600]">MessagesSquare</code>, <code className="text-[#FF6600]">Shield</code>, <code className="text-[#FF6600]">Rocket</code>). Browse names at <span className="underline">lucide.dev/icons</span>.
      </p>
    </div>
  );
};
